import { useContext } from 'react';

import { PrevLocationContext } from 'src/contexts/PrevLocationContext';

// ----------------------------------------------------------------------

const usePrevLocation = () => useContext(PrevLocationContext);

export default usePrevLocation;
